// Re-export the canonical BlogPost type instead of defining a new one
export type { BlogPost, BlogPostForm } from '@/types/db/blogPost';
export { transformBlogPost } from '@/types/db/blogPost';

export interface BlogPostCreateInput {
  title: string;
  slug: string;
  summary: string;
  content: string;
  featured_image: string;
  tags?: string[];
  published?: boolean;
  meta_title?: string;
  meta_description?: string;
  reading_time_minutes?: number;
  author_id?: string;
  author_name?: string;
}

export interface BlogPostUpdateInput {
  title?: string;
  slug?: string;
  summary?: string;
  content?: string;
  featured_image?: string;
  tags?: string[];
  published?: boolean;
  meta_title?: string;
  meta_description?: string;
  publish_status_changed?: boolean;
  reading_time_minutes?: number;
  updated_at?: string;
  published_at?: string | null;
}

import { z } from 'zod';

export const blogPostSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  slug: z.string().min(1, 'Slug is required'),
  content: z.string().min(1, 'Content is required'),
  summary: z.string().min(1, 'Summary is required'),
  tags: z.array(z.string()).default([]),
  published: z.boolean().default(false),
  meta_title: z.string().optional(),
  meta_description: z.string().optional(),
  author_name: z.string().optional(),
  featured_image: z.string().optional(),
});

export type BlogPostFormData = z.infer<typeof blogPostSchema>;
